module.exports = __webpack_public_path__ + "img/semla.80bb37fb.png";